/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Typography, useTheme, Link } from '@mui/material';

import { FOOTER_HEIGHT } from '../../utils/constants';

export const Footer = () => {
	const theme = useTheme();
	return (
		<div
			css={css`
				flex: 1;
				display: flex;
				justify-content: center;
				align-items: center;
				background: ${theme.palette.background.paper};
				min-height: ${FOOTER_HEIGHT};
			`}>
			<Typography
				css={css`
					word-spacing: 0.1rem;
					text-transform: uppercase;
				`}
				variant='caption'
				color='textSecondary'>
				© {new Date().getFullYear()} unEventful by The Bawdy Shop |{' '}
				<Link href='mailto:julianh2o@gmail.com' color='inherit' underline='hover'>
					Contact
				</Link>
			</Typography>
		</div>
	);
};
